import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    { icon: 'ri-dashboard-line', label: '仪表盘', path: '/admin/dashboard' },
    { icon: 'ri-article-line', label: '文章管理', path: '/admin/articles' },
    { icon: 'ri-sticky-note-line', label: '笔记管理', path: '/admin/notes' },
    { icon: 'ri-image-line', label: '作品集管理', path: '/admin/portfolio' },
    { icon: 'ri-line-chart-line', label: '学习进度管理', path: '/admin/progress' },
    { icon: 'ri-home-gear-line', label: '首页内容管理', path: '/admin/home-content' },
    { icon: 'ri-user-settings-line', label: '用户管理', path: '/admin/users' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
            易无忧
          </h1>
          <p className="text-sm text-gray-600 mt-1">后台管理系统</p>
        </div>

        <nav className="flex-1 p-4 overflow-y-auto">
          {menuItems.map(item => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors whitespace-nowrap ${
                location.pathname === item.path
                  ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <i className={`${item.icon} text-xl`}></i>
              <span className="font-medium">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-200">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-cyan-400 rounded-full flex items-center justify-center text-white font-bold">
              {user?.username.charAt(0).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-gray-900 truncate">{user?.username}</div>
              <div className="text-sm text-gray-500">管理员</div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
          >
            <i className="ri-logout-box-line"></i>
            退出登录
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}